import { Type } from '@sinclair/typebox';

const searchFiltersSchema = Type.Object({
    sourceType: Type.Optional(Type.String()),
    objectId: Type.Optional(Type.String({ format: 'uuid' })),
    surveyId: Type.Optional(Type.String({ format: 'uuid' })),
});

const searchRequestSchema = Type.Object({
    query: Type.String({ minLength: 1 }),
    clientCompanyId: Type.Optional(Type.String({ format: 'uuid' })),
    filters: Type.Optional(searchFiltersSchema),
    limit: Type.Optional(Type.Number()),
});

const searchResultSchema = Type.Object({
    sourceType: Type.String(),
    sourceId: Type.String(),
    chunkText: Type.String(),
    parentText: Type.String(),
    similarity: Type.Number(),
    combinedScore: Type.Number(),
    sectionTitle: Type.Union([Type.String(), Type.Null()]),
    sourceName: Type.Union([Type.String(), Type.Null()]),
    sourceUrl: Type.Union([Type.String(), Type.Null()]),
    metadata: Type.Union([Type.String(), Type.Null()]),
});

const searchResponseSchema = Type.Object({
    results: Type.Array(searchResultSchema),
});

export const aiSearchPaths = {
    '/api/ai/search': {
        post: {
            operationId: 'aiSearchControllers.search',
            requestBody: {
                content: {
                    'application/json': {
                        schema: searchRequestSchema,
                    },
                },
            },
            responses: {
                '200': {
                    description: 'Hybrid vector + full-text search results with parent context',
                    content: {
                        'application/json': {
                            schema: searchResponseSchema,
                        },
                    },
                },
            },
        },
    },
} as const;
